import React from 'react'

const PartnersFeature = () =>
  <div className="page feature">
    <h1>Partner Offers</h1>
  </div>

export default PartnersFeature
